module.exports = __webpack_public_path__ + "img/appDownload.0d90a0a7.png";